// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ResponsiveSnapchatFooter_footerContainer__pVSXs","footerExpanded":"ResponsiveSnapchatFooter_footerExpanded__9Z4CS"};